module.exports = __webpack_public_path__ + "static/media/henshalls.007a0c98.jpg";